import React, { FC, PropsWithChildren } from "react";
import { Button, Steps } from "../../components";
import cn from "classnames";
import stl from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { useStore } from "effector-react";
import {
  $currentStep,
  nextStep,
  prevStep,
  goToStep,
  $steps,
} from "../../steps/stepsStore";
import { usePageSize } from "../../hooks";
import { AppConfig } from "../../config";

interface Props {
  className?: PropsWithChildren<HTMLDivElement>["className"];
}
const Footer: FC<Props> = ({ className }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.steps);
  const currentStep = useStore($currentStep);
  const steps = useStore($steps);
  const pageSize = usePageSize();

  return (
    <div className={cn(className, stl.block)}>
      <div className={stl.inner}>
        <div style={{ textAlign: "left" }}>
          {currentStep > 0 && (
            <Button
              size={!pageSize.md ? "small" : undefined}
              onClick={prevStep}
              disabled={currentStep <= 0}
            >
              {t("prev")}
            </Button>
          )}
        </div>

        {pageSize.sm && (
          <Steps current={currentStep} onChange={goToStep}>
            {steps.map(({ tKey }) => (
              <Steps.Step
                key={tKey}
                title={pageSize.md ? t(tKey) : undefined}
              />
            ))}
          </Steps>
        )}

        <div style={{ textAlign: "right" }}>
          {currentStep < steps.length - 1 && (
            <Button
              size={!pageSize.md ? "small" : undefined}
              variant={"primary"}
              disabled={currentStep >= steps.length - 1}
              onClick={nextStep}
            >
              {t("next")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
